import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import Menu from './Menu';
import Documents from './Documents';
import Services from './Services';
import Privacy from './documents/privacy';
import Aup from './documents/aup';
import Tos from './documents/tos';
import AppPrivacy from './documents/app-privacy';
import AppSupport from './documents/app-support';
import AppTerms from './documents/app-terms';
import Internet from './services/internet';
import Tv from './services/tv';
import Phone from './services/phone';
import Acp from './programs/acp';
import Rates from './rates';
import Bundle from './bundle';
import './Sec1.css';

const Sec1 = () => (
  <Router>
    <div>
      <section id="one" className="doc">
        <Route path='/' exact component={Menu} />
        <Route path='/documents' exact component={Documents} />
        <Route path='/services' exact component={Services} />
        <Route path='/privacy' component={Privacy} />
        <Route path='/aup' component={Aup} />
        <Route path='/tos' component={Tos} />
        <Route path='/app-privacy' component={AppPrivacy} />
        <Route path='/app-support' component={AppSupport} />
        <Route path='/app-terms' component={AppTerms} />
        <Route path='/internet' component={Internet} />
        <Route path='/phone' component={Phone} />
        <Route path='/acp' component={Acp} />
        <Route path='/rates' component={Rates} />
        <Route path="/bundle" component={Bundle} />
      </section>
    </div>
  </Router>
);

export default Sec1;


// WEBPACK FOOTER //
// ./src/components/sections/Sec1.js